// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --winterColor: #9E0505;
  --summerColor: #19398E;
}

.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component {
  padding-bottom: 0;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

.icon-state {
  font-size: 24px;
}
.icon-state.icon-state-season {
  color: #3498db;
}
.icon-state.icon-state-season.summer {
  color: #f9ca24;
}
.icon-state.icon-state-hvac {
  color: #10ac84;
}
.icon-state.icon-state-windows {
  color: #c0392b;
}
.icon-state.icon-state-fancoil, .icon-state.icon-state-valve {
  color: var(--ion-color-medium-shade);
}

::ng-deep .vimar .icon-state.comfort {
  color: #0D5E93;
}
::ng-deep .vimar .icon-state.standby {
  color: #449989;
}
::ng-deep .vimar .icon-state.eco {
  color: #DEDEDE;
}
::ng-deep .vimar .icon-state.protection {
  color: #2D9F79;
}

.auto-icon {
  font-weight: 600;
  color: var(--ion-color-medium-shade);
}

.container-icon-state {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-basis: 100%;
  margin-block-end: 10px;
}

.setpoint {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: #707070;
  line-height: 1;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.setpoint > span {
  font-size: 13px;
  letter-spacing: 0;
}

.visible-section {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

.icon-main {
  width: var(--size-icon-main);
  height: var(--size-icon-main);
  flex-shrink: 0;
  background-color: var(--summerColor);
  color: rgba(255, 255, 255, 0.8);
  font-size: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-main.isWinter {
  background-color: var(--winterColor);
}

::ng-deep .vimar .thermostat-icon {
  background-color: transparent !important;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .icon-main {
  font-size: 70px;
}
.supervision-view .title {
  font-size: 15px;
}

app-draggable-slider + app-draggable-slider {
  margin-block-start: 16px;
}

.text-actual-temperature {
  font-weight: 700;
  line-height: 1;
  font-size: 26px;
}

.toggle-button {
  color: var(--ion-color-medium-shade);
  display: block;
  font-size: 24px;
  cursor: pointer;
  margin-inline: auto;
  margin-block-start: 5px;
}

.master-thermostat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-block-start: 30px;
}

@media screen and (min-width: 400px) {
  .labels.fancoil-command {
    width: calc(100% - 40px);
    margin-inline: auto;
  }
  .labels.fancoil-command + app-draggable-slider {
    margin-inline: 16px;
  }
}
.labels {
  display: flex;
  justify-content: space-between;
  height: auto;
  margin-block: 10px 5px;
}
.labels span {
  font-size: 27px;
  font-weight: 600;
  color: var(--ion-color-medium-tint);
}
.labels span.active {
  color: var(--summerColor);
}

.isWinter > span.active {
  color: var(--winterColor);
}

.title-label {
  margin-block: 30px 10px;
  text-transform: uppercase;
  font-size: 14px;
  color: #8b8b8b;
  font-weight: 700;
  text-align: center;
}

.container-command {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(var(--height-smart-component-compact) - var(--padding-component) - var(--size-icon-main));
}

app-thermostat-expanded-section,
.container-slider {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-thermostat/widget-thermostat.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,sBAAA;AADF;;AAIA;ECNI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADMJ;ACJI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADMR;ACHI;EACI,UAAA;ADKR;AAtBA;EAGE,iBAAA;AAsBF;;AAnBA;EC4CI,kFAAA;EACA,WAAA;ADrBJ;;AApBA;EACE,eAAA;AAuBF;AArBE;EACE,cAAA;AAuBJ;AArBI;EACE,cAAA;AAuBN;AAnBE;EACE,cAAA;AAqBJ;AAlBE;EACE,cAAA;AAoBJ;AAjBE;EAEE,oCAAA;AAkBJ;;AAZE;EACE,cAAA;AAeJ;AAZE;EACE,cAAA;AAcJ;AAXE;EACE,cAAA;AAaJ;AAVE;EACE,cAAA;AAYJ;;AARA;EACE,gBAAA;EACA,oCAAA;AAWF;;AARA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAWF;;AARA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AAWF;AATE;EACE,eAAA;EACA,iBAAA;AAWJ;;AAPA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAUF;;AAPA;ECtEI,aAAA;EACA,mBAAA;EACA,SAAA;ADiFJ;AC/EI;EACI,2BAAA;EACA,iBAAA;ADiFR;AC9EI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADgFR;AC9EQ;EACI,gBAAA;ADgFZ;AC5EI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;AD8ER;;AA3BA;ECzCI,4BAAA;EACA,6BAAA;EACA,cAAA;EDyCF,oCAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAgCF;AA9BE;EACE,oCAAA;AAgCJ;;AA5BA;EACE,wCAAA;AA+BF;;AA5BA;ECtDI,eAAA;EACA,gBAAA;ADsFJ;;AA5BE;EACE,eAAA;AA+BJ;AA5BE;EACE,eAAA;AA8BJ;;AAxBE;EACE,wBAAA;AA2BJ;;AAvBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA0BF;;AAvBA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AA0BF;;AAvBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,wBAAA;AA0BF;;AAvBA;EAEE;IACE,wBAAA;IACA,mBAAA;EAyBF;EAvBE;IACE,mBAAA;EAyBJ;AACF;AArBA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AAuBF;AArBE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;AAuBJ;AArBI;EACE,yBAAA;AAuBN;;AAlBA;EACE,yBAAA;AAqBF;;AAlBA;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,0GAAA;AAqBF;;AAlBA;;EAEE,WAAA;AAqBF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n:host {\n  --winterColor: #9E0505;\n  --summerColor: #19398E;\n}\n\n.container-smart-component {\n  @include external-apparance;\n\n  padding-bottom: 0;\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\n.icon-state {\n  font-size: 24px;\n\n  &.icon-state-season {\n    color: #3498db;\n\n    &.summer {\n      color: #f9ca24;\n    }\n  }\n\n  &.icon-state-hvac {\n    color: #10ac84;\n  }\n\n  &.icon-state-windows {\n    color: #c0392b;\n  }\n\n  &.icon-state-fancoil,\n  &.icon-state-valve {\n    color: var(--ion-color-medium-shade);\n  }\n\n}\n\n::ng-deep .vimar {\n  .icon-state.comfort {\n    color: #0D5E93;\n  }\n\n  .icon-state.standby {\n    color: #449989;\n  }\n\n  .icon-state.eco {\n    color: #DEDEDE;\n  }\n\n  .icon-state.protection {\n    color: #2D9F79;\n  }\n}\n\n.auto-icon {\n  font-weight: 600;\n  color: var(--ion-color-medium-shade);\n}\n\n.container-icon-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-basis: 100%;\n  margin-block-end: 10px;\n}\n\n.setpoint {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 22px;\n  font-weight: 600;\n  color: #707070;\n  line-height: 1;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n\n  &>span {\n    font-size: 13px;\n    letter-spacing: 0;\n  }\n}\n\n.visible-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n}\n\n.icon-and-text {\n  @include icon-and-text;\n}\n\n.icon-main {\n  @include icon-main;\n  background-color: var(--summerColor);\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 50px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &.isWinter {\n    background-color: var(--winterColor);\n  }\n}\n\n::ng-deep .vimar .thermostat-icon {\n  background-color: transparent !important;\n}\n\n.title {\n  @include title-main;\n}\n\n.supervision-view {\n  .icon-main {\n    font-size: 70px;\n  }\n\n  .title {\n    font-size: 15px;\n  }\n}\n\napp-draggable-slider {\n\n  &+app-draggable-slider {\n    margin-block-start: 16px;\n  }\n}\n\n.text-actual-temperature {\n  font-weight: 700;\n  line-height: 1;\n  font-size: 26px;\n}\n\n.toggle-button {\n  color: var(--ion-color-medium-shade);\n  display: block;\n  font-size: 24px;\n  cursor: pointer;\n  margin-inline: auto;\n  margin-block-start: 5px;\n}\n\n.master-thermostat {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  margin-block-start: 30px;\n}\n\n@media screen and (min-width: 400px) {\n\n  .labels.fancoil-command {\n    width: calc(100% - 40px);\n    margin-inline: auto;\n\n    &+app-draggable-slider {\n      margin-inline: 16px;\n    }\n  }\n}\n\n.labels {\n  display: flex;\n  justify-content: space-between;\n  height: auto;\n  margin-block: 10px 5px;\n\n  span {\n    font-size: 27px;\n    font-weight: 600;\n    color: var(--ion-color-medium-tint);\n\n    &.active {\n      color: var(--summerColor);\n    }\n  }\n}\n\n.isWinter>span.active {\n  color: var(--winterColor);\n}\n\n.title-label {\n  margin-block: 30px 10px;\n  text-transform: uppercase;\n  font-size: 14px;\n  color: #8b8b8b;\n  font-weight: 700;\n  text-align: center;\n}\n\n.container-command {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: calc(var(--height-smart-component-compact) - var(--padding-component) - var(--size-icon-main));\n}\n\napp-thermostat-expanded-section,\n.container-slider {\n  width: 100%;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
